export const MIN_SNAP = 0.3;
export const MAX_SNAP = 1;
